import type { BuildAudienceData } from './BuildAudienceContext';

/**
 * The build-audience wizard's initial state.
 *
 * Its own module for two reasons. Exporting it from the context file trips
 * react-refresh/only-export-components ("use a new file to share constants or functions
 * between components"), and tests need the REAL default: buildAudienceDraft.test.ts used
 * to hand-write `{ userProvidedCompetitors: [] }` while this ships THREE blank slots, so
 * it could not catch the bug where an untouched page counted as "3 competitors" worth
 * restoring. A fixture that diverges from the real initial state tests a product that
 * does not exist.
 *
 * `import type` for BuildAudienceData, so the context can import this value back without
 * a runtime cycle.
 */
export const initialBuildAudienceData: BuildAudienceData = {
  simulationTarget: null,
  audienceScope: null,
  websiteUrl: '',
  specificSegment: '',
  qualitativeInfo: '',
  uploadedFile: null,
  uploadedFileContent: null,
  foundationalResearch: '',
  businessModel: null,
  userProvidedCompetitors: [
    { name: '', url: '' },
    { name: '', url: '' },
    { name: '', url: '' },
  ],
  competitors: [],
  segments: [],
  globalChatHistory: [],
  segmentationFocus: '',
  segmentationApproach: '',
  lastModifiedStep: undefined,
};
